import { createContext } from 'react';

export interface InputContextValue {
  id: string;
}

export const InputContext = createContext<InputContextValue | null>(null);
